import { useState } from "react";
import { IoChevronDownSharp } from "react-icons/io5";
import { FaQuestion, FaCheck } from "react-icons/fa";

export default function StatusDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState("Active");
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [pendingStatus, setPendingStatus] = useState("");

  const handleClick = (value) => {
    setPendingStatus(value);
    setIsOpen(false);
    setShowConfirmModal(true);
  };

  const handleConfirm = () => {
    setSelected(pendingStatus);
    setShowConfirmModal(false);
    setShowSuccessModal(true);
  };

  const handleCloseSuccess = () => {
    setShowSuccessModal(false);
  };

  const handleCancel = () => {
    setPendingStatus("");
    setShowConfirmModal(false);
  };

  return (
    <div className="relative inline-block text-left w-32">
      {/* Dropdown Button */}
      <div
        onClick={() => setIsOpen(!isOpen)}
        className={`flex items-center justify-between px-3 py-1.5 rounded-md cursor-pointer border text-sm ${
          selected === "Active"
            ? "bg-green-100 text-green-700"
            : "bg-red-100 text-red-700"
        }`}
      >
        {selected}
        <IoChevronDownSharp className="ml-2" />
      </div>

      {/* Dropdown List */}
      {isOpen && (
        <div className="absolute mt-1 w-full rounded-md border bg-white shadow-md z-10">
          <div
            onClick={() => handleClick("Active")}
            className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm"
          >
            Active
          </div>
          <div
            onClick={() => handleClick("Deactive")}
            className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm"
          >
            Deactive
          </div>
        </div>
      )}

      {/* Confirmation Modal */}
      {showConfirmModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg text-center shadow-lg w-80">
            <div className="flex justify-center mb-4">
              <div className="bg-red-500 text-white rounded-full w-14 h-14 flex items-center justify-center text-2xl">
                <FaQuestion />
              </div>
            </div>
            <p className="text-base font-medium px-4 mb-4">
              Are you sure you want to change the product status to{" "}
              <b>{pendingStatus}</b>?
            </p>
            <div className="flex justify-center gap-4">
              <button
                className="border border-red-500 text-red-500 px-6 py-1 rounded hover:bg-red-100"
                onClick={handleCancel}
              >
                Cancel
              </button>
              <button
                className="bg-red-600 text-white px-8 py-1 rounded hover:bg-red-700"
                onClick={handleConfirm}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Success Modal */}
      {showSuccessModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-2 py-5 rounded-lg text-center shadow-lg w-80">
            <div className="flex justify-center mb-4">
              <div className="bg-red-500 text-white rounded-full w-14 h-14 flex items-center justify-center text-2xl">
                <FaCheck />
              </div>
            </div>
            <p className="text-base font-medium px-4 mb-4">
              The product status has been successfully changed to{" "}
              <b>{pendingStatus}</b>. ✅
            </p>
            <button
              className="bg-red-600 text-white px-6 py-2 rounded hover:bg-red-700"
              onClick={handleCloseSuccess}
            >
              Done
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
